import { createApp } from 'vue';
import App from './App.vue';

import VueGoogleMaps from '@fawmi/vue-google-maps';
import { createVuetify } from 'vuetify';
import 'vuetify/styles'; // Import the Vuetify styles
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import '@mdi/font/css/materialdesignicons.css'
import store from './store';
import router from './router'; // Import the router


const vuetify = createVuetify({
    components,
    directives,
  });

const app = createApp(App);

// Set global properties
const apiBaseUrl = process.env.VUE_APP_API_BASE_URL;
app.config.globalProperties.$API_BASE_URL = apiBaseUrl;
app.use(vuetify);
app.use(store);
app.use(router); // Use the router

// Initialize Google Maps
app.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyDHHjdFB_rgArGIFeCKfyf1d1NTNy4xCMk',
    },
});

app.mount('#app');
